import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private isLoading$ = new BehaviorSubject<boolean>(false);

  public isLoading = this.isLoading$.asObservable().pipe(distinctUntilChanged());

  public setLoading(isLoading: boolean) {
    this.isLoading$.next(isLoading);
  }
}
